import { render, staticRenderFns } from "./AddMessage.vue?vue&type=template&id=4cca3e4c&scoped=true&"
import script from "./AddMessage.vue?vue&type=script&lang=js&"
export * from "./AddMessage.vue?vue&type=script&lang=js&"
import style0 from "./AddMessage.vue?vue&type=style&index=0&id=4cca3e4c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cca3e4c",
  null
  
)

export default component.exports